import { LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export const AccountDeactivated = () => {
  const { signOut } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full bg-card border border-border rounded-2xl p-8 text-center shadow-soft">
        <h2 className="text-2xl font-serif font-semibold text-foreground mb-3">
          Account deactivated
        </h2>
        <p className="text-muted-foreground leading-relaxed mb-6">
          Your account has been deactivated. If you'd like to reactivate it, please contact us at{" "}
          <a href="mailto:privacy@fbn-i.org" className="text-primary underline underline-offset-2 hover:text-primary/80">
            privacy@fbn-i.org
          </a>.
        </p>
        <Button variant="outline" onClick={signOut} className="w-full">
          <LogOut className="w-4 h-4 mr-2" />
          Log out
        </Button>
      </div>
    </div>
  );
};
